import type { ReactNode } from 'react';

export const GRAPH_PARTICLE_TICKET_PERFORATION_WIDTH = 10;
export const RELATED_GRAPH_PAP_STRIP_EXTENSION_WIDTH = 240;
export const RELATED_GRAPH_OVERLAY_STRIP_WIDTH = 200;
export const RELATED_GRAPH_SIDE_STRIPS_EXTENSION_WIDTH =
  RELATED_GRAPH_PAP_STRIP_EXTENSION_WIDTH
  + RELATED_GRAPH_OVERLAY_STRIP_WIDTH * 2;
export const WORKSPACE_PARTICLE_CARD_WIDTH = 272;

export function GraphParticleTicketShell({
  selected,
  children,
}: {
  selected?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={
        'flex overflow-hidden rounded-xl border bg-surface shadow-card transition '
        + (selected
          ? 'border-2 border-primary-strong shadow-[0_8px_24px_rgba(15,108,189,0.18)]'
          : 'border-border')
      }
    >
      {children}
    </div>
  );
}

export function GraphParticleTicketPerforation({ selected }: { selected?: boolean }) {
  return (
    <div
      className="relative shrink-0 self-stretch"
      style={{ width: GRAPH_PARTICLE_TICKET_PERFORATION_WIDTH }}
      aria-hidden
    >
      <div className={`absolute inset-y-0 left-0 w-1/2 ${selected ? 'bg-canvas' : 'bg-surface'}`} />
      <div className="absolute inset-y-0 right-0 w-1/2 bg-[#EAF2FF]/70" />
      <div
        className={`absolute inset-y-1 left-1/2 w-px -translate-x-1/2 border-l border-dashed ${
          selected ? 'border-primary/50' : 'border-border'
        }`}
      />
    </div>
  );
}
